export default "__VITE_ASSET__CmrR375H__"